import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=d5b4dcf8&"
import script from "./HomePage.vue?vue&type=script&lang=ts&setup=true&"
export * from "./HomePage.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=d5b4dcf8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports